/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsCustomWarning,
    AssetsMelcoModelsCustomWarningFromJSON,
    AssetsMelcoModelsCustomWarningFromJSONTyped,
    AssetsMelcoModelsCustomWarningToJSON,
    AssetsMelcoModelsSupplier,
    AssetsMelcoModelsSupplierFromJSON,
    AssetsMelcoModelsSupplierFromJSONTyped,
    AssetsMelcoModelsSupplierToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsGenericList1MelcoModelsSupplier
 */
export interface AssetsMelcoModelsGenericList1MelcoModelsSupplier {
    /**
     * 
     * @type {Array<AssetsMelcoModelsSupplier>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsSupplier
     */
    list: Array<AssetsMelcoModelsSupplier>;
    /**
     * 
     * @type {Array<AssetsMelcoModelsCustomWarning>}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsSupplier
     */
    warning_list?: Array<AssetsMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof AssetsMelcoModelsGenericList1MelcoModelsSupplier
     */
    total: number;
}

export function AssetsMelcoModelsGenericList1MelcoModelsSupplierFromJSON(json: any): AssetsMelcoModelsGenericList1MelcoModelsSupplier {
    return AssetsMelcoModelsGenericList1MelcoModelsSupplierFromJSONTyped(json, false);
}

export function AssetsMelcoModelsGenericList1MelcoModelsSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsGenericList1MelcoModelsSupplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AssetsMelcoModelsSupplierFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(AssetsMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function AssetsMelcoModelsGenericList1MelcoModelsSupplierToJSON(value?: AssetsMelcoModelsGenericList1MelcoModelsSupplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AssetsMelcoModelsSupplierToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(AssetsMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


